import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_GA_CARD_ORDER_VIRTUAL } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const MultiCurrencyPage = () => {
    const messages = usePageMessages();
    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName="cardp-mastercard-thin"
                iconColor="primary"
                headerText={<DangerouslyHtml dangerouslyHtml={messages.multiCurrencyTitle} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={messages.multiCurrencyText} />}
                primaryButtonCaption={messages.continueButton}
                primaryButtonType="link"
                primaryButtonLink={AUTH_GA_CARD_ORDER_VIRTUAL}
            />
        </BaseLayout>
    );
};

export default BasePage(MultiCurrencyPage);
